import { z } from 'zod';
import { deepPartialOrNullable } from '../../../../helpers';
import { baseAiGeneratedResponseSchema } from './baseAiGeneratedResponseSchema';
import { AiCareDocumentTreatmentDetailsSchema } from './AiCareDocumentTreatmentDetailsSchema';
import { AiCareDocumentWorkDetailsSchema } from './AiCareDocumentWorkDetailsSchema';
import { CareDocumentOvercomeChallengeSchema } from '../CareDocumentOvercomeChallengeSchema';
import { AiDateSchema } from './AiDateSchema';

export const InitialAssessmentSummaryAiGeneratedSchema = z.object({
  patient: z
    .object({
      cancerType: z.string().nullish(),
      dob: AiDateSchema,
      dateOfDiagnosis: AiDateSchema,
      work: deepPartialOrNullable(AiCareDocumentWorkDetailsSchema).nullish(),
    })
    .nullish(),
  perciStartDate: AiDateSchema,
  dateOfConsultation: AiDateSchema,

  treatmentDetails: deepPartialOrNullable(
    AiCareDocumentTreatmentDetailsSchema,
  ).nullish(),

  planToOvercomeChallenges: z
    .array(deepPartialOrNullable(CareDocumentOvercomeChallengeSchema))
    .nullish(),

  expertSummary: z.string().nullish(),
});

export type InitialAssessmentSummaryAiGenerated = z.infer<
  typeof InitialAssessmentSummaryAiGeneratedSchema
>;

export const InitialAssessmentSummaryAiGeneratedResponseSchema =
  baseAiGeneratedResponseSchema(InitialAssessmentSummaryAiGeneratedSchema);

export type InitialAssessmentSummaryAiGeneratedResponse = z.infer<
  typeof InitialAssessmentSummaryAiGeneratedResponseSchema
>;
